
import { defineComponent } from "vue";
import { MainAppController } from "../../controllers/MainAppController";

export default defineComponent({
  name: "ToastSuccessV2",
  setup() {
    return {
      data: MainAppController.snackbarData,
    };
  },
  methods: {
    close() {
      MainAppController.setSnackbar(false);
    },
  },
});
